import type { CatalogueOverviewContent } from '../content/catalogue-overviews';
import { WebsiteDocument } from './website-document';
import '../assets/catalogue.css';
import '../assets/theme-content.css';

export function CatalogueOverview({ content }: { content: CatalogueOverviewContent }) {
    return <section className="catalogue-content catalogue-overview p-4 overflow-y-auto" style={{ flex: 1, minHeight: 0 }}
        aria-label={content.heading}>
        <h2 className="mt-0">{content.heading}</h2>
        <WebsiteDocument blocks={content.blocks} />
    </section>;
}
